import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

import { TModalComponentsItemProps } from '../../types/productSeriesDetailFeature.types';
import Banner from '../componentDetails/banner';
import CTAButton, { ctaEnums } from '../../../@shared/ctaButton';
import CTAWithArrow from '../../../@shared/ctaWithArrow';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { appendRootToRichTextInternalLinks } from '../../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../../utils/appendRootToInternalLink.utils';

const InnerSplitModule: FC<TModalComponentsItemProps> = (props) => {
  const model = props.component;
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);

  return (
    <div className="inner-split-module" style={{ backgroundColor: props.backgroundColor || '#F4F4F4' }}>
      <div className="inner-split-module__image-wrapper">
        <Banner
          mediaHeightClassName="inner-split-module__media-height"
          component={model}
          mediaCarouselClassName="inner-split-module__media-carousel"
          shouldShowOnlyFirstItem={true}
          desktopRenditionKey={'rendition_desktop_size1000'}
          mobileRenditionKey={'rendition_mobile_size500'}
        />
      </div>
      <div className="inner-split-module__text-wrapper">
        <p className="inner-split-module__eyebrow">{model?.eyebrow}</p>
        <RichText editable={false} field={{ value: model?.title }} tag="h2" className="inner-split-module__title rich-text" />
        <RichText
          editable={false}
          field={{ value: appendRootToRichTextInternalLinks(model?.description) }}
          tag="div"
          className="inner-split-module__description rich-text"
        />
        <div className={'inner-split-module__buttons'}>
          {(model?.button1?.url || model?.button1?.label) && (
            <CTAButton type={ctaEnums.primaryRed}>
              <RoutableNotEditableLink
                className="inner-split-module__primary-link"
                href={appendRootToInternalLink(model?.button1?.url)}
                target={targetLinkdsk({ value: { href: model?.button1?.url, target: model?.button1?.target } }, isDesktop)}
              >
                {model?.button1?.label}
              </RoutableNotEditableLink>
            </CTAButton>
          )}
          {(model?.button2?.url || model?.button2?.label) && (
            <CTAWithArrow
              href={appendRootToInternalLink(model?.button2?.url) || ''}
              text={model?.button2?.label}
              target={targetLinkdsk({ value: { href: model?.button2?.url, target: model?.button2?.target } }, isDesktop)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InnerSplitModule;
